import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	DESKTOP_M_BP,
	TABLET_M_BP,
	TABLET_BP,
	MOBILE_LM_BP,
	MOBILE_ML_BP,
	MOBILE_M_BP,
	MOBILE_SM_BP,
	COLOR_DARK_GREEN_BUTTON,
	COLOR_BACKGROUND_GREEN,
} from "@website-builder/utilities-index";

export const CTASliderWrapper = styled.div`
	padding: 84px 65px 115px 65px;
	background-color: ${COLOR_BACKGROUND_GREEN};

	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		width: 100%;
		text-align: center;
		padding-bottom: 50px;
	}

	.content {
		width: 55%;
		float: right;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		h3 {
			font-size: 23px;
			font-weight: ${FONT_WT_MEDIUM};
		}
		p {
			font-weight: ${FONT_WT_LIGHT};
		}
		p {
			strong {
				font-weight: ${FONT_WT_MEDIUM};
			}
		}
	}

	.buttonContainer {
		float: right;
		left: 45%;
		margin-top: -8%;
		position: absolute;
		padding-left: 5px;
	}

	.application-button {
		margin-top: 20px;
		padding: 0px 20px 0px 20px;
	}

	.slick-slide {
		div {
			div {
				outline: none;
			}
		}
	}

	.slick-slide img {
		display: inherit;
	}
	.slick-dots {
		width: 30%;
		bottom: -30px;
	}
	.slick-dots li {
		margin: 0px;
	}
	.slick-dots li.slick-active button:before {
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-dots li button:before {
		font-size: 15px;
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-prev:before {
		display: none;
	}
	.slick-next:before {
		display: none;
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) and (min-width: ${DESKTOP_SM_BP}px) {
		padding: 60px 45px 80px 45px;
		.content {
			width: 48%;
			margin-top: -3%;
		}
		.buttonContainer {
			margin-top: -5%;
			left: 51%;
		}
		.image {
			width: 40%;
		}
		.slick-dots {
			width: 40%;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP -
		1}px) and (min-width: ${TABLET_BP}px) {
		padding: 40px 30px 80px 30px;
		.image {
			width: 40%;
		}
		.buttonContainer {
			margin-top: -3%;
		}
		.slick-dots {
			width: 40%;
			bottom: -15px !important;
		}
		.content {
			margin-top: -4%;
		}
	}

	@media only screen and (max-width: ${TABLET_BP -
		1}px) and (min-width: ${MOBILE_L_BP - 1}px) {
		padding: 40px 20px 50px 20px;
		.image {
			width: 50%;
		}
		.buttonContainer {
			left: 54%;
			margin-top: -4%;
		}
		.slick-dots {
			width: 50%;
			bottom: 290px;
		}
		.content {
			width: 45%;
			margin-top: -4%;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 50px 30px 80px 30px;
		.content {
			width: 100%;
			padding-top: 30px;
		}
		.image {
			width: 100%;
		}
		.buttonContainer {
			width: 100%;
			margin-top: -6%;
			position: unset;
			padding-left: 0px;
		}
		.slick-dots {
			width: 100%;
			bottom: 310px !important;
		}
	}

	@media only screen and (max-width: ${MOBILE_LM_BP}px) {
		.slick-dots {
			bottom: 350px;
		}
	}

	@media only screen and (max-width: ${MOBILE_ML_BP}px) {
		.slick-dots {
			bottom: 345px !important;
		}
	}

	@media only screen and (max-width: ${MOBILE_SM_BP}px) {
		.slick-dots {
			bottom: 390px !important;
		}
	}
`;
